<template>
  <router-link
    class="xrow"
    @click="$emit('setSelectedApplication', application)"
    :to="`/${pageName.toLowerCase()}/${application.referenceId}`"
  >
    <div class="container">
      <div class="left">
        <div class="xcell xname" name="left">
          <div class="xusericon" data-size="small" v-if="false">
            <div class="xusericon-picture">
              {{ decodeHTMLEncodedStr(application.initials) || "" }}
            </div>
          </div>

          <div class="xpage-openapps-box-name">
            <div class="name-container">
              <h4
                :title="application.name"
                v-html="decodeHTMLEncodedStr(application.name) || 'No Name'"
              ></h4>

              <span class="xdetails" v-if="layout === 'table'">
                <div class="xdetails-group">
                  <h3 class="subtitle xsmall-text">
                    <span>
                      {{ application.createdAtFormatted }}
                    </span>
                    |
                    <span
                      v-if="application.referenceIdSearchNotification"
                      class="xcell xsearchtext"
                      v-html="application.referenceIdSearchNotification"
                    ></span>
                    <span v-else class="xcell xsearchtext">{{
                      application.referenceId
                    }}</span>
                  </h3>
                </div>
              </span>
            </div>

            <h5
              class="xlender"
              :title="application.lenderName || application.defaultLenderName"
            >
              {{ application.lenderName || application.defaultLenderName }}
            </h5>
            <div
              class="xcoapplicant-container"
              v-if="application.nameCoApplicant"
            >
              <i class="icon-people"></i>&nbsp;
              <span
                class="xcoapplicant xsearchtext xsmall-text"
                v-html="application.nameCoApplicant"
              ></span>
            </div>

            <h6 v-if="application.searchNotification" class="xsearch-notification" v-html="application.searchNotification"></h6>
						<div v-if="application.searchNotifications" class="xsearch-notifications" v-html="application.searchNotifications"></div>
          </div>
        </div>

        <!-- Legacy Code; displays the status for each tab -->
        <!-- <div class="xcell xstatuses" style="display: none">
      <div class="xicon-on-tile xtooltip">
        <span class="xtooltiptext">Income</span>
        <div class="xicon-status icon-ok-circle"></div>
        <i class="icon-money"></i>
      </div>
      <div class="xicon-on-tile xtooltip">
        <span class="xtooltiptext">Identity</span>
        <div class="xicon-status icon-ok-circle"></div>
        <i class="icon-adult"></i>
      </div>
      <div class="xicon-on-tile xtooltip">
        <span class="xtooltiptext">Membership</span>
        <div class="xicon-status icon-ok-circle"></div>
        <i class="icon-bank"></i>
      </div>
      <div class="xicon-on-tile xtooltip">
        <span class="xtooltiptext">E-Sign</span>
        <div class="xicon-status icon-ok-circle"></div>
        <i class="icon-pencil-alt"></i>
      </div>
      <div class="xicon-on-tile xtooltip">
        <span class="xtooltiptext">Credit</span>
        <div class="xicon-status icon-ok-circle"></div>
        <i class="icon-credit-card"></i>
      </div>
      <div class="xicon-on-tile xtooltip">
        <span class="xtooltiptext">E-Sign</span>
        <div class="xicon-status icon-ok-circle"></div>
        <i class="icon-pencil-alt"></i>
      </div>
      <div class="xicon-on-tile xtooltip">
        <span class="xtooltiptext">Credit</span>
        <div class="xicon-status icon-ok-circle"></div>
        <i class="icon-credit-card"></i>
      </div>
    </div> -->

        <div class="xdetails" v-if="layout === 'boxes'">
          <div class="xdetails-group">
            <h3 class="subtitle xsmall-text">
              <span>
                {{ application.createdAtFormatted }}
              </span>
              |

              <span
                v-if="application.referenceIdSearchNotification"
                class="xsearchtext"
                v-html="application.referenceIdSearchNotification"
              ></span>
              <span
                v-else
                class="xsearchtext"
                v-html="application.referenceId"
              ></span>
            </h3>
          </div>
          <div class="xdetails-group">
            <span class="xpill light">{{ application.statusName }}</span>
          </div>
        </div>
      </div>
      <div class="right">
        <div
          class="xcell xdetails-group"
          name="status"
          v-if="layout === 'table'"
        >
          <span class="xpill light">{{ application.statusName }}</span>
        </div>
      </div>
    </div>
  </router-link>
</template>

<script setup lang="ts">
import useFunctions from "@/use/functions1";

const { decodeHTMLEncodedStr } = useFunctions();

const props = defineProps<{
  application: any;
  pageName: string;
  layout: "boxes" | "table";
}>();

const emit = defineEmits<{
  (event: "setSelectedApplication", application: any): void;
}>();
</script>

<style scoped src="@/assets/css/search-page/search-page-dashboard.css"></style>
<style scoped src="@/assets/css/search-page/application-card.css"></style>
